module.exports = __webpack_public_path__ + "static/media/Entertainment.d25ee030.jpg";